import { render, staticRenderFns } from "./PointOfSaleTag.vue?vue&type=template&id=241f7b3f&scoped=true&"
import script from "./PointOfSaleTag.vue?vue&type=script&lang=js&"
export * from "./PointOfSaleTag.vue?vue&type=script&lang=js&"
import style0 from "./PointOfSaleTag.vue?vue&type=style&index=0&id=241f7b3f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "241f7b3f",
  null
  
)

export default component.exports